import React from 'react';
import { useCookies } from 'react-cookie';
import { useMatch } from 'react-router';
import { useListLiveProjectsQuery } from '../../../../../../generated/core-api/graphql-react-query';
import { State } from '../useGlobalStoreContext';

export default function useProjectIdState(): { projectId: State<string | null>, rawProjectId?: string } {
  const [cookies, setCookies, clearCookies] = useCookies(['current-project']);

  const cardPathMatch = useMatch('/projects/:projectId/cards/:cardId');
  const projects = useListLiveProjectsQuery({});

  const currentValue = React.useMemo(() => {
    if (cardPathMatch?.params.projectId) {
      return cardPathMatch.params.projectId;
    }
    return cookies['current-project'];
  }, [cookies['current-project'], cardPathMatch]);

  const safeCurrentValue = React.useMemo(() => {
    if (projects.data) {
      if (!projects.data.listProjects.some((p) => p.id === currentValue)) {
        return null;
      }
    }
    return currentValue;
  }, [projects.data, currentValue]);

  return React.useMemo(() => ({
    projectId: [
      safeCurrentValue,
      (newValue: string | null) => {
        if (newValue === null) clearCookies('current-project', { path: '/' });
        else {
          setCookies(
            'current-project',
            newValue,
            {
              path: '/', maxAge: 60 * 60 * 24 * 365, secure: true, sameSite: 'strict',
            },
          );
        }
      },
    ],
    rawProjectId: cookies['current-project'],
  }), [safeCurrentValue, cookies['current-project']]);
}
